import "./assets/styles/index.scss";
import { Outlet } from "react-router-dom";
import "./Fontawesome";
import secondaryComponents from "./components/secondaryComponents";
import {
  ManagerOtpPermission,
  WebSocketConnectHelper,
} from "./components/common";
import Meta from "./Meta";
import { useEffect } from "react";
// layout imports
import { MainLayout } from "./layouts/index";
import { QueryClient, QueryClientProvider } from "react-query";
import Routes from "./routes/Routes";
const queryClient = new QueryClient();

const App = () => {
  useEffect(() => {
    // eslint-disable-next-line no-undef
    if (process.env.REACT_APP_ENV === "production") {
      window.console.warn = () => {};
      window.console.log = () => {};
      window.console.error = () => {};
    }
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <Routes>
        <WebSocketConnectHelper>
          <MainLayout>
            <secondaryComponents.ApiErrorHandler>
              <secondaryComponents.SubscribeUpgradeNotification>
                <secondaryComponents.ToastMessage>
                  <ManagerOtpPermission>
                    <Meta />
                    <Outlet />
                  </ManagerOtpPermission>
                </secondaryComponents.ToastMessage>
              </secondaryComponents.SubscribeUpgradeNotification>
            </secondaryComponents.ApiErrorHandler>
          </MainLayout>
        </WebSocketConnectHelper>
      </Routes>
    </QueryClientProvider>
  );
};
export default App;
